export class WCBaseComponent extends HTMLElement {

  constructor () {
    super();
  }

  connectedCallback () {
    if (this.hasRendered) return;
    this.hasRendered = true;
    this.render();
  }

  render () {
  }

}